import React from 'react';
import styled from 'styled-components/macro';
import Animation from '../../Animation';
import Link from '@material-ui/core/Link';
import { getEncodedToken } from '../../../utils/getJWT';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { IconButton as _IconButton, Tooltip } from '@material-ui/core';

const Card = styled(Animation)`
  && {
    border: 1px solid #e0e0e0;
    margin: 0.8em 0;
    padding: 0.8em;
    min-height: 5em;
    border-radius: 10px;
    position: relative;
  }

  [class*='Mui-expanded'] {
    margin: 0 !important;
    min-height: 30px !important;
  }
  [class*='MuiPaper-elevation1'] {
    box-shadow: none;
  }
  [class*='MuiExpansionPanelSummary-content'] {
    margin: 0 !important;
  }
  [class*='MuiExpansionPanelSummary-root'] {
    padding: 0;
  }
  [class*='MuiExpansionPanelSummary-root Mui-focused'] {
    background-color: #fff !important;
  }
  [class*='MuiExpansionPanelDetails-root'] {
    display: block;
    padding: 0;
  }
`;

const IconButton = styled(_IconButton)`
  && {
    background-color: transparent !important;
    color: #4c84ff;
    padding: 0 0 7px;
  }
`;

const CardContents = styled.div`
  display: flex;
`;

const TextSection = styled.div`
  flex: 1;
  font-weight: 500;
`;

const ControlsSection = styled.div`
  align-items: center;
  display: flex;
  gap: 1rem;
  width: 70px;
`;

const TaskFileCardView = props => {
  return (
    <Card>
      <CardContents>
        <TextSection>
          {/* <Tooltip title="foo">{props.displayFilename}</Tooltip> */}
          <Tooltip title={props.filename}>
            <span>{props.displayFilename}</span>
          </Tooltip>{' '}
          ({Math.max(props.size / 1048576.0, 0.1).toFixed(1)} MB)
        </TextSection>
        <ControlsSection>
          <Link
            href={props.downloadUrl + '?jwt=' + getEncodedToken()}
            title="Download"
            target="_blank"
            rel="noopener noreferrer"
            download
            data-testid="file-download-link"
          >
            <Tooltip title="Download">
              <CloudDownloadIcon />
            </Tooltip>
          </Link>
          {!props.viewOnly && (
            <IconButton onClick={props.onClickedDelete}>
              <Tooltip title="Delete">
                <DeleteOutlineIcon />
              </Tooltip>
            </IconButton>
          )}
        </ControlsSection>
      </CardContents>
    </Card>
  );
};

export default TaskFileCardView;
